<script lang="ts">
  import { page } from "$app/stores";
  import { primaryColor } from "$stores/community";
  import { beforeNavigate } from "$app/navigation";
  import OVIcon from "$components/+shared/OVIcon/OVIcon.svelte";
  import Avatar from "$components/+shared/Avatar/Avatar.svelte";
  import cx from "classnames";
  import type { IconType } from "$components/+shared/OVIcon/OVIcon";

  export let path: string;
  export let routeId: string | undefined = undefined;
  export let title: string;
  export let icon: IconType | undefined = undefined;
  export let avatar: string | undefined = undefined;
  export let openInNewTab: boolean = false;
  export let hideOnMobile: boolean = false;

  let isCurrentLocation: boolean;

  $: {
    if (routeId && $page.route.id) {
      isCurrentLocation = $page.route.id.startsWith(routeId);
    }
  }

  beforeNavigate((nav) => {
    const targetPath = `/${nav.to?.url.pathname}`;
    isCurrentLocation = `/${targetPath}`.includes(path);
  });
</script>

<a
  href={path}
  class={cx(
    "relative flex h-[28px] items-center justify-center rounded-md border border-black/10 text-sm font-medium max-sm:h-[36px] max-sm:w-[36px] max-sm:border-gray-300 sm:border-none sm:px-2 sm:py-1.5 md:text-[13px] dark:border-black/5 max-sm:dark:border-white/10",
    {
      "text-gray-500/70 transition-colors hover:text-black dark:text-gray-400 hover:dark:text-white":
        !isCurrentLocation,
      "text-black after:absolute after:inset-x-0 after:-bottom-[13px] after:h-[1px] after:rounded-t-[0.5px] after:bg-community-primary sm:after:-bottom-[16px] dark:text-white":
        isCurrentLocation,
    }
  )}
  {...openInNewTab && { target: "_blank" }}
  on:click
>
  {#if avatar}
    <Avatar
      mainImage={avatar}
      backgroundColor={$primaryColor}
      wrapperClasses="mr-2"
      radius="rounded"
    />
  {/if}

  <span class="hidden max-w-[16ch] truncate sm:flex">{title}</span>
  {#if !hideOnMobile && icon}
    <span class="block sm:hidden"><OVIcon {icon} /></span>
  {/if}
</a>
